module.exports = __webpack_public_path__ + "img/trigerVideo.4b1b783c.png";